import { useTranslation } from 'react-i18next';
import { PageLayout } from 'src/common/components/AppLayout/PageLayout';
import { TablePageTitle } from 'src/common/components/AppLayout/TablePage/TablePageTitle';
import { AdminTabsLayout } from './AdminTabsLayout';

const AdminPageTitle = () => {
  const { t } = useTranslation();

  return <TablePageTitle>{t('customFields.admin')}</TablePageTitle>;
};

export const AdminPageLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <PageLayout title={<AdminPageTitle />}>
      <AdminTabsLayout>{children}</AdminTabsLayout>
    </PageLayout>
  );
};
